
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 21","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.395 2.361C4.141 1.299 5.396.571 7.292.571h3.633c.473 0 .857.384.857.858v3.29a.857.857 0 01-.857.857h-2.5l.001.047v.714h2.717a.857.857 0 01.852.946l-.344 3.29a.857.857 0 01-.852.768H8.426v8.602a.857.857 0 01-.857.857H3.374a.857.857 0 01-.857-.857V11.34H.857A.857.857 0 010 10.484v-3.29c0-.473.384-.857.857-.857h1.66v-.911c0-.855.17-2.055.878-3.065zm1.403.985c-.426.607-.567 1.405-.567 2.08v1.768a.857.857 0 01-.857.857h-1.66v1.576h1.66c.473 0 .857.384.857.857v8.602h2.48v-8.602c0-.473.384-.857.858-.857h2.458l.164-1.576H7.57a.857.857 0 01-.857-.857V5.66a1.665 1.665 0 01.442-1.254A1.696 1.696 0 018.41 3.86h.002-.004 1.66V2.286H7.292c-1.402 0-2.105.506-2.494 1.06z"}})])
          )
        }
      }
    